export const ScalpelIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 20l9.5-9.5"/>
    <path d="M13.5 10.5L20 4c.5-.5.5-1.5 0-2s-1.5-.5-2 0l-6.5 6.5"/>
    <path d="M13.5 10.5c1 1 1 2.5 0 3.5l-5 5c-1 1-2.5 1-3.5 0"/>
  </svg>
);
